<template>
  <div class="chat-online" v-bind:style="{ maxHeight: elementHeight + 'px' }">

    <div class="icon-container" :class="{ loadingBackground: loading }">
      <transition name="icontransition">
        <img
          key="legalIcon"
          v-if="state === 'legal' && !loading"
          src="./../assets/people.png"
          class="legal-icon"
          alt="Legal section icon"
        >
        <img
          key="chatIcon"
          v-if="state != 'legal' && !loading"
          src="./../assets/chat.png"
          class="chat-icon"
          alt="Chat section icon"
        >
      </transition>

      <div class="loading-text" v-if="loading">
        <div class="spinner">
          <div class="double-bounce1"></div>
          <div class="double-bounce2"></div>
        </div>Connecting to chat
      </div>
    </div>

    <div class="chat-content" ref="chatContent">

      <div class="chat-background-loading" v-if="state ==='chat'"></div>

      <transition name="contenttransition">
        <div key="legal" class="legal-container" v-if="state==='legal'">
          <h3>Chat is online</h3>
          <p class="no-free-agents" v-if="!agentsIdle">However all online Cancer Support Advisors are currently busy. Please feel free to continue to the chat and wait, or submit a callback request <button @click="sendCallbackToParent">here</button>.</p>
          <p>Thank you for contacting 131120. Before we start, we need to provide you with our privacy collection statement.
13 11 20 is provided by Cancer Council Queensland. During your chat, a member of our team may need to collect some personal and health information from you in order to provide information or link you into support and appropriate services. Your personal information may be provided to third parties where required by law, or so that such third parties may provide Cancer Council Queensland with services. Please refer to Cancer Council Queensland’s Privacy Policy for further details, available on <a target="_blank" href="https://cancerqld.org.au/about-us/our-privacy-policy/">here</a> or upon request. We will take reasonable steps to ensure that such third parties deal with your information appropriately, and only for Cancer Council Queensland purposes. Our Privacy Policy explains how you can contact us to access and correct your personal information or make a privacy complaint. You can contact us at <a href="mailto:privacyofficer@cancerqld.org.au">privacyofficer@cancerqld.org.au</a> or write to us at: Privacy Officer, Cancer Council Queensland, P.O Box 201, Spring Hill, Queensland 4004.</p>
          <button
            class="legal-btn btn"
            v-on:click="updateState('details')"
          >I accept and would like to chat</button>
        </div>

        <div key="details" class="details-container" v-if="state==='details'">
          <h3>Enter your details to start a chat</h3>
          <DetailsForm ref="detailsForm" />
        </div>

        <div key="chat" class="chat-container" v-if="state==='chat'" v-bind:style="{ height: elementHeight + 'px' }">
          <PureCloudChat v-bind:userDetails="this.form" @chatEnded="closeChat()"/>
        </div>
      </transition>
    </div>
  </div>
</template>

<script>
import DetailsForm from "./detailsForm";
import PureCloudChat from "./purecloudChat";

export default {
  name: "ChatOnline",
  components: { DetailsForm, PureCloudChat },
  props: {
    loading: {
      type: Boolean
    },
    agentsIdle: {
      type: Boolean
    }
  },
  data: () => ({
    state: "legal",
    elementHeight: null,
    form: {}
  }),
  methods: {
    sendCallbackToParent: function() {
      this.$parent.$emit('callbackClicked', true)
    },

    updateState: function(changedState) {
      this.state = changedState;

      if (changedState === 'details') {
        setTimeout(() => {
          this.updateHeight();
        }, 300);
      }
    },
    updateHeight: function() {
      this.elementHeight = this.$refs.chatContent.offsetHeight;
    }
  },
  mounted: function() {
    this.updateHeight();

    this.$on("formComplete", function() {
      this.form = this.$refs.detailsForm.form;
      this.updateState("chat")
    });

    window.onresize = () => {
      this.updateHeight();
    }
  }
};
</script>

<style scoped lang="scss">
@use "./_responsive.scss" as *;

@keyframes fade-in {
  0% {
    opacity: 0;
    transform: translateY(00px);
  }
  100% {
    opacity: 1;
    transform: translateY(0px);
  }
}

@keyframes enter-circle {
  0% {
    opacity: 0.6;
    transform: scale(0);
  }
  100% {
    opacity: 0;
    transform: scale(1);
  }
}

.contenttransition-enter-active,
.contenttransition-leave-active {
  transition: all 0.23s;
}

.contenttransition-enter-active {
  transition-delay: 0.2s;
}

.contenttransition-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateX(-10px);
}

.contenttransition-enter {
  opacity: 0;
  transform: translateX(10px);
}

.icontransition-enter-active,
.icontransition-leave-active {
  transition: all 0.6s;
}
.icontransition-enter, .icontransition-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: rotate(-90deg) scale(0);
}

@keyframes grow-circle {
  0% {
    transform: scaleX(0);
  }
  100% {
    transform: scaleX(1);
  }
}

iframe.webchat-frame {
  border: none !important;
}

.chat-online {
  max-width: 1000px;
  margin: 0 auto;
  background: white;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.12), 0 1px 2px rgba(0, 0, 0, 0.24);
  border-radius: 4px;
  padding-left: 150px;
  overflow: hidden;
  animation: 1s fade-in forwards;
  transition: .2s all ease-in-out;

  @include tablet {
    padding-left: 0;
  }

  @include mobile {
    text-align: center;
  }

  .chat-background-loading {
    height: 100%;
    width: 100%;
    background: #f3f3f3;
    position: absolute;
    bottom: 0;
    left: 0;
    transform: scaleX(0);
    animation: 0.4s 0.4s grow-circle forwards;
    transform-origin: left;
  }

  .icon-container {
    width: 150px;
    background: #fcd207;
    height: 100%;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 9999999999999999999999999;
    transition: 0.4s all ease-in-out;

    img {
      filter: brightness(0);
      // opacity: 0.5;
    }

    @include tablet {
      width: 100%;
      height: 100px;
    }

    img {
      position: absolute;
      top: 0;
      bottom: 0;
      margin: auto;
      margin-left: 40px;
      transition: 0.3s all ease-in-out;

      &.legal-icon {
        // margin-left: 10px;
        left: 10px;
      }

      @include tablet {
        left: 0 !important;
        right: 0;
        margin: 0 auto;
      }

      &.chat-icon {
        margin-left: 50px;

        @include tablet {
          margin: 0 auto;
          left: 0;
          right: 0;
          margin-top: 50px;
        }
      }
    }
  }

  .chat-content {
    padding: 30px;
    padding-top: 40px;
    color: white;
    width: 80%;
    margin: 0 auto;
    padding-bottom: 40px;

    @include tablet {
      padding-left: 0;
      padding-right: 0;
      padding-top: 150px;
    }

    &.whiteBackground {
      background: white;
    }

    .legal-container {

      h3 {
        margin-bottom: 10px;
      }
      .legal-btn {
        // background: $teal;
        margin-top: 30px;
        color: white;
      }
    }

    .details-container {
      h3 {
        margin-bottom: 20px;
      }
    }
  }
}
.loadingBackground {
  width: 100% !important;
  height: 100% !important;
}

.loading-text {
  position: absolute;
  top: 0;
  bottom: 0;
  margin: auto;
  color: white;
  text-align: center;
  width: 100%;
  display: block;
  font-weight: 700;
  height: fit-content;
  font-size: 20px;
}

.spinner {
  width: 40px;
  height: 40px;

  position: relative;
  margin: 0 auto;
  margin-bottom: 10px;
}

.double-bounce1,
.double-bounce2 {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  background-color: white;
  opacity: 0.6;
  position: absolute;
  top: 0;
  left: 0;

  -webkit-animation: sk-bounce 2s infinite ease-in-out;
  animation: sk-bounce 2s infinite ease-in-out;
}

.double-bounce2 {
  -webkit-animation-delay: -1s;
  animation-delay: -1s;
}

@-webkit-keyframes sk-bounce {
  0%,
  100% {
    -webkit-transform: scale(0);
  }
  50% {
    -webkit-transform: scale(1);
  }
}

@keyframes sk-bounce {
  0%,
  100% {
    transform: scale(0);
    -webkit-transform: scale(0);
  }
  50% {
    transform: scale(1);
    -webkit-transform: scale(1);
  }
}

.no-free-agents {
  // color: #3c6072;
  color: #0f1e64;
  font-weight: 700;
  margin-bottom: 10px;

  a {
    color: #009bdc!important;
  }
}
</style>
